<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <WIN_subpagehero />
        <WIN_two_column_text />
        <WIN_two_column_fullbleed />

    </main>

</template>


<script>
    import WIN_subpagehero from "../../../components/content/enterprise/benefit/WIN_subpagehero";
    import WIN_two_column_text from "../../../components/content/enterprise/benefit/WIN_two_column_text";
    import WIN_two_column_fullbleed from "../../../components/content/enterprise/benefit/WIN_two_column_fullbleed";


    export default {
        name: 'WIN_Benefit',
        components:{
            WIN_subpagehero,
            WIN_two_column_text,
            WIN_two_column_fullbleed,

        }

    }


</script>

<style>



</style>